import { toLuxon } from 'tdr-common';

export const epochToDisplayTime = (epochInSeconds: number, timezone: string) => {
	const luxonDateTime = toLuxon(epochInSeconds, timezone);
	return luxonDateTime.toFormat('h:mma');
};